<script setup>
import { watch } from "vue";
import { useQuery } from "@tanstack/vue-query";
import { httpClientOmni } from "@/libraries";
import useChatPanelFilter from "@/store/pinia/use-chat-panel-filter";
import { storeToRefs } from "pinia";
import getDecodedUserId from "@/helpers/get-decoded-user-id";
import useRole from "@/composables/use-role";

const filterStore = useChatPanelFilter();
const { filter } = storeToRefs(filterStore);

useQuery({
  queryKey: ["QUERY_GET_APP_CONFIG"],
  queryFn: async () => {
    const response = await httpClientOmni.get("app");

    return response.data.data?.app || null;
  },
});

// Use the centralized role composable (shares cache, no redundant API calls)
const { isAgent } = useRole();

// Watch for role changes to update filter
watch(
  isAgent,
  (newIsAgent) => {
    filterStore.setFilter({
      ...filter.value,
      status: newIsAgent ? "live" : "",
    });
  },
  { immediate: true }
);
</script>

<template>
  {{ console.log("getDecodedUserId", getDecodedUserId("boQrZB")) }}
  {{ "" }}
</template>
